module.exports = __webpack_public_path__ + "static/media/img_system3.5ce4048f.png";